module.exports = __webpack_public_path__ + "img/image 2.7459bf4f.png";